import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function AccountDeleted() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6" data-testid="account-deleted-page">
      <div className="max-w-lg w-full border-2 border-zinc-900 p-10 sm:p-12">
        <div className="w-12 h-12 bg-zinc-900 text-white flex items-center justify-center mb-6">
          <CheckCircle2 size={22} strokeWidth={1.75} />
        </div>
        <div className="label-tiny">ReInVocation</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight mt-2">
          Your account has been deleted
        </h1>
        <p className="text-zinc-600 mt-4 leading-relaxed">
          All of your data — jobs, resume, settings, and engagement history — has been permanently
          removed from our systems. There is nothing left to recover.
        </p>
        <p className="text-zinc-600 mt-3 leading-relaxed text-sm">
          Thank you for using ReInVocation. We wish you the very best in your job hunt. You're always
          welcome back — signing in again will start you with a fresh account.
        </p>
        <Button asChild className="rounded-none bg-zinc-900 hover:bg-zinc-800 text-white h-11 px-6 mt-8" data-testid="goodbye-home-btn">
          <Link to="/">Back to home</Link>
        </Button>
      </div>
    </div>
  );
}
